$(document).ready(function(){
	if($('form.upload-form').length > 0) {
		let endpoint = $('form.upload-form').data('endpoint');
		let curPage = 1;
		let responseFiles = null;

		let url_filetypes = endpoint + '/filetypes';
		$.ajax({
			type: "GET",
			url: url_filetypes,
			dataType: 'json',
			success: function (data) {
				let filetypes = data.filetypes;
				if(filetypes.length > 0) {
					let filetype = null;
					for (var i = filetypes.length - 1; i >= 0; i--) {
						filetype = filetypes[i];
						$('#field-upload-file-type').append('<option value="' + filetype.id + '">' + filetype.title + '</option>');
					}

					$('#field-upload-file-type').selectric('refresh');
				}
			},
			error: function (e) {
				console.log(e)
			}
		});

		// file list
		let url_datafiles = endpoint + '/files';
		let file_params = {
			"customer": {
				"id": $('input[name="upload[customer_id]"]').val()
			}
		};
		$.ajax({
			type: "POST",
			url: url_datafiles,
			data: file_params,
			dataType: 'json',
			success: function (data) {
				responseFiles = data;
				renderFilesTable(data);
			},
			error: function (e) {
				console.log(e)
			}
		});

		$(document).on('click', 'a.file-download', function(){
			const $tr = $(this).closest('tr');
			const id = $tr.data('id');
			const hostname = url_domain(endpoint);
			const customer_id = $('input[name="upload[customer_id]"]').val();
			let url_download = hostname + '/download/' + customer_id + '/' + id;

			location.href = url_download;
		});

		$(document).on('click', 'a.file-delete', function(){
			const $tr = $(this).closest('tr');
			const id = $tr.data('id');
			let url_delete = endpoint + '/files/delete';

			let file_params = {
				"customer": {
					"id": $('input[name="upload[customer_id]"]').val(),
					"file_id": id
				}
			};
			$.ajax({
				type: "POST",
				url: url_delete,
				data: file_params,
				dataType: 'json',
				success: function (data) {
					responseFiles = data;
					renderFilesTable(data);
				}
			});
		});

		$(document).on('click', '.pagination_files a', function(){
			let _no = $(this).data('no');

			curPage = _no;
			renderFilesTable(responseFiles);
		});

		function renderFilesTable(data) {
			console.log(data)
			let datafiles = data.datafiles;
			let filetypes = data.filetypes;
			if(datafiles.length > 0) {
				let perPage = parseInt(window.uploads.perpage);
				let totalPages = Math.ceil(datafiles.length / perPage);
				let start = perPage * (curPage - 1);
				let end = perPage * curPage;
				if(end > datafiles.length) {
					end = datafiles.length;
				}
				let _file = null;
				let _tr = '';
				$('.section-account__files table tbody').html('');

				let $pageWrapper = $('.pagination_files ul');
				for(var i=start; i<end; i++) {
					_file = datafiles[i];
					_tr = '<tr data-id="' + _file.id + '">';
					_tr += '<td class="row_pdf">';
					_tr += '<span>' + getFileTitle(_file.file.url) + '</span>';
					_tr += '<span>' + getFileType(filetypes, _file.filetype_id) + '</span>';
					_tr += '</td>';
					_tr += '<td class="col_time">' + getFileTime(_file.created_at) + '</td>';
					_tr += '<td class="col_desc">' + _file.description + '</td>';
					_tr += '<td>' + _file.order_id + '</td>';
					_tr += '<td>' + _file.quote_id + '</td>';
					_tr += '<td class="col_option">';
					_tr += '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z" /></svg>';
					_tr += '<ul>';
					_tr += '<li><a class="btn file-download">Download</a></li>';
					_tr += '<li><a class="btn file-delete">Delete</a></li>';
					_tr += '</ul>';
					_tr += '</td>';
					_tr += '</tr>';

					$('.section-account__files table tbody').append(_tr);
				}

				if(totalPages > 1) {
					let _li = '';
					$pageWrapper.html('');
					for(var i=1; i<=totalPages; i++) {
						if(curPage == i) {
							_li = '<li><span>' + i + '</span></li>';
						} else {
							_li = '<li><a data-no="' + i + '"><span>' + i + '</span></a></li>';
						}

						$pageWrapper.append(_li);
					}
				} else {
					$pageWrapper.html('');
				}
			} else {
				$('.section-account__files table tbody').html('');
				let _tr = '<tr><td colspan="6" class="col_empty">No uploaded files.</td></tr>';
				$('.section-account__files table tbody').append(_tr);
			}
		}
	}

	function url_domain(data) {
	  var    a      = document.createElement('a');
	         a.href = data;
	  return 'https://' + a.hostname;
	}

	function getFileTitle(url) {
		return url.substring(url.lastIndexOf('/')+1);
	}

	function getFileType(obj, id) {
		let _type = "";
		for (var i = obj.length - 1; i >= 0; i--) {
			if(obj[i].id == id) {
				_type = obj[i].title;
			}
		}

		return _type;
	}

	function getFileTime(str) {
		var date = new Date(str);
		var monthNames = [
		  "January", "February", "March",
		  "April", "May", "June", "July",
		  "August", "September", "October",
		  "November", "December"
		];

		var day = date.getDate();
		var monthIndex = date.getMonth();
		var year = date.getFullYear();

		return monthNames[monthIndex] + ' ' + day + ', ' + year;
	}
});


// WEBPACK FOOTER //
// ../assets/js/upload-file.js